const disabledStyle = {
  // color: 'gray',
  pointerEvents: "none", // Disables clicking
  cursor: "not-allowed", // Shows a not-allowed cursor
  textDecoration: "none", // Removes underline
};

export { disabledStyle };
